<template>
  <div class="wcm-order-container">
    <!--    全案营销-->
    <div class="container h-100" style="background-color: #fff">
      <div class="content">
        <div class="header">
          <search-form ref="search" :query-params.sync="searchCondition" class="search-form" :can-export="false"
                       :show-order-way="false" :configs="MapSearchConfigs" default-time-query
                       @handleQuery="onSubmit">
            <div style="float:right;margin-bottom: 10px;display: flex;">
              <!--      修改合作形式        -->
              <change-cooperation :cooperation="cooperation" :selection="pageSelectedList" @success="getList"/>
              <!--          申请开票-->
              <apply-invoice-opt :data-list="pageSelectedList" @applied="afterDeal" is-wcm/>
              <!--          合同归档-->
              <AdContractOpt :data-list="pageSelectedList" @afterContract="afterDeal"/>
              <!--        显示列-->
              <set-tbl-columns @success="getList()" style="margin-right: 10px;"/>
              <export-btn size="mini" :can-export="userAuth.can_export_adv_order" btn-type="warning"
                          @export="handleExport('refExportBtn')" ref="refExportBtn" :lint-title="`导出`"
                          style="margin-right:10px;"/>
              <el-button @click="handleAdd" class="d-flex-row funcbars-button el-button--operation"
                         v-if="userAuth.can_create_adv_order" size="mini" style="margin-right: 10px">
                <i class="el-icon-plus"></i>新增项目({{ this.cooperation || '' }})
              </el-button>
            </div>
          </search-form>
        </div>

        <!--    广告订单列表表格  -->
        <div class="tableCon default-table">
          <el-table :data="dataList"
                    ref="table"
                    v-loading="loading"
                    :expand-row-keys="expandKeys"
                    :row-key="`id`"
                    @selection-change="handleSelectionChange"
                    highlight-current-row border>
            <el-table-column type="selection" width="55" fixed="left"/>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <ChildOrderTable :pt="pt" :pid="scope.row.id" :key="`child-table-${key}`" :is-pre-executor="isPreExecutor" />
              </template>
            </el-table-column>
            <el-table-column key="操作项" label="操作项" header-align="center" align="center" class-name="handle-row"
                             width="140">
              <template slot-scope="{row,$index}">
                <div class="buttons d-flex-row align-items-center">
                  <el-button size="mini" type="text" icon="el-icon-plus" @click="handleCommand('child',row)"
                             :disabled="!(userAuth.can_create_adv_order)" v-if="row.bool_undo===0">添加子单
                  </el-button>
                </div>
                <AdOptColumn :row="row" :row-index="$index" :onlyMore="true" editRouteName="editAdOrderWcm"
                             :is-pre-executor="isPreExecutor" :pt="pt"
                             @refreshOrderList="afterDeal"/>
              </template>
            </el-table-column>
            <el-table-column label="订单编号" prop="order_no" width="160" align="center">
              <template slot-scope="scope">
                <to-order-detail :pt="pt" :order="scope.row" :is-pre-executor="isPreExecutor" />
              </template>
            </el-table-column>
            <el-table-column label="乙方名称" prop="company_name" width="100" align="center"></el-table-column>
            <el-table-column label="客户名称" prop="customer_name" width="200" align="center" show-overflow-tooltip>
              <template slot-scope="{row}">
                <el-link type="primary" @click="goDetail(row)">
              <span style="padding: 1px 1px; background-color: #FF5722; color: #fff; font-size: 12px;"
                    v-show="row.order_type === 'strike' || row.order_type === '冲账类型'"
              >冲</span>
                  {{ row.customer_name || '-' }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column label="执行" prop="pre_executor" width="100" align="center"></el-table-column>
            <el-table-column label="招商" prop="commerce" width="100" align="center"></el-table-column>
            <el-table-column label="销售" prop="sale" width="100" align="center"></el-table-column>
            <el-table-column label="客户性质" prop="customer_nature" header-align="center" align="center"/>
            <el-table-column label="品牌" prop="brand" width="100" align="center"></el-table-column>
            <!--            <el-table-column label="品牌集团" prop="combine_brand_name" width="100" align="center"></el-table-column>-->
            <el-table-column label="行业" prop="trade" width="100" align="center"></el-table-column>
            <el-table-column label="产地" prop="place_of_origin" width="100" align="center"></el-table-column>
            <!--            品牌集团  行业-->
            <el-table-column label="产品/内容" width="100" prop="product" header-align="center"></el-table-column>
            <el-table-column label="订单来源" prop="order_source" width="100" align="center"></el-table-column>
            <el-table-column label="客单" prop="passenger_order_interval" width="100" align="center"></el-table-column>
            <!--            客单-->
            <el-table-column label="品类" prop="product_category" header-align="center"></el-table-column>
            <el-table-column label="合作形式" prop="form_of_cooperation" header-align="center"></el-table-column>
            <el-table-column label="红人名称" prop="artist_name" header-align="center"></el-table-column>
            <!--合作形式 -->
            <el-table-column label="含税收入" prop="payment_account" width="120" header-align="center"
                             align="right"></el-table-column>
            <el-table-column label="回款金额" prop="sum_amount" width="120" header-align="center" align="right" />
            <el-table-column label="应收款" prop="remain_account" width="120" header-align="center" align="right" />
            <el-table-column label="结款方式" prop="pm_list" width="120" header-align="center" align="right" />
            <el-table-column label="备注" prop="remark" width="120" align="center"/>
            <el-table-column label="收款形式" prop="payment_method_alias" width="120" align="center"/>
            <el-table-column label="合同归档" prop="contract_filed_alias" width="120" align="center"/>
            <el-table-column label="合同编号" prop="contract_no" width="120" align="center"/>
            <el-table-column label="合同金额" prop="contract_amount" width="120" align="center"/>
            <el-table-column label="财务备注" prop="f_remark" width="120" align="center"/>
            <el-table-column label="直播次数" prop="live_count" width="120" align="center"/>
            <el-table-column label="是否保次数" prop="is_quantity_times_alias" width="120" align="center"/>
            <el-table-column label="是否保量" prop="is_quantity_alias" width="120" align="center"/>
            <el-table-column label="保量金额" prop="gq_amount" width="120" align="center"/>
            <el-table-column label="保量进度" prop="accrue_schedule" width="120" align="center">
              <template v-slot="{row:{accrue_schedule}}">
                {{ accrue_schedule|numberFormat(2) }}%
              </template>
            </el-table-column>
            <el-table-column label="直播GMV" width="120" align="center">
              <template v-slot="{row:{live_gmv}}">
                {{ live_gmv|numberFormat(2) }}
              </template>
            </el-table-column>
            <el-table-column label="是否完结" prop="is_done_order_alias" width="120" align="center"/>
            <el-table-column label="创建时间" prop="created_at" width="140" align="center">
              <template slot-scope="{row}">
                <span :title="row.updated_at">{{ row.created_at }}</span>
              </template>
            </el-table-column>
            <el-table-column label="下单月份" prop="created_month" width="140" align="center" />
            <el-table-column label="执行公司" prop="exec_customer_name" width="140" align="center" />
          </el-table>
          <div>
            <el-row :gutter="15">
              <el-col :span="24" style="text-align: right">
                <pagination :total.sync="total" :limit.sync="pageData.per_page" :page.sync="pageData.page"
                            @pagination="getList"/>
              </el-col>
            </el-row>
          </div>

        </div>
      </div>
    </div>

    <MergeOrder :visible.sync="openMerge" :order-ids="ids" @close="getList" v-if="userAuth.order_merge_project"/>
  </div>
</template>

<script>
import {exportWcm, queryWcmOrdersList} from "@/api/adOrder";
// import SearchForm from "./components/SearchForm";
import SearchForm from "@/views/adOrder/order/components/SearchForm.vue";
import ChildOrderTable from "./components/ChildOrderTable";
import MergeOrder from "./components/MergeOrder";
import AdContractOpt from "@/views/adOrder/components/AdContractOpt";
import ApplyInvoiceOpt from "@/views/adOrder/components/ApplyInvoiceOpt";
import {getOptionsForSelect} from "@/api/option";
import AdOptColumn from "@/views/adOrder/components/AdOptColumn";
import ToOrderDetail from "../components/ToDetail";
import SetTblColumns from "../components/SetTblColumns.vue";
import {judgeOrderWholeCase} from "@/views/adOrder";
import ExportBtn from "@/components/export/ExportBtn.vue";
import ChangeCooperation from "./components/ChangeCooperation.vue";

const MapSearchConfigs = [
  'customer_id', 'order_source', 'time_type', 'sale_id', 'brand', 'product_category', 'artist_id',
  'customer_nature', 'strategy_id', 'planner_id', 'medium_id', 'bool_undo', 'order_no', 'contract_filed',
  'contract_no', 'is_mark_invoiced', 'invoice_status', 'is_can_invoice', 'project_name', 'is_done_order',
  'is_quantity', 'customer_name', 'is_done_stage', 'trade'
];
/**
 * 全案营销项目列表（主订单包含子订单）
 */
export default {
  name: "AdWcm",
  components: {
    ChangeCooperation,
    ExportBtn,
    MergeOrder,
    SearchForm,
    ChildOrderTable,
    ApplyInvoiceOpt,
    AdOptColumn,
    ToOrderDetail,
    SetTblColumns,
    AdContractOpt
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  props: {
    cooperation: {
      type: String,
      default() {
        return null
      }
    },
    pt: Number, // 操作类型；1：普通订单，2：全案营销，3：普客打包，4：年框大全案，5：纯直播
  },
  data() {
    return {
      MapSearchConfigs,
      loading: false,
      key: new Date().getTime,
      // 选中数组
      ids: [],
      pay_methods: [],
      pageSelectedList: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      dataList: [],
      pageData: {page: 1, per_page: 15},
      isPreExecutor: 1,
      total: 0,
      offset: 0,
      searchCondition: {
        time_type: 'created_timestamp',
        timeRange: [],
        orderBy: '`id` desc',
        agent_name: null,
        brand: null,
        company_id: null,
        form_of_cooperation: null,
        order_type: null,
        bool_undo: 0,
        contract_no: null,
        contract_filed: null,
        customer_id: [],
        order_no: [],
        order_nos: '',
        is_lb: [],
        is_trailer: [],
        pay_status: [],
        invoice_status: [],
        sale_id: [],
        platform: [],
        order_source: [],
        artist_id: [],
        bool_exec: [],
        is_mark_invoiced: null,
        is_mark_rebate: null,
        is_can_invoice: null,
        is_new_customer: null,
        bool_covenant: null,
        invoice_number: null,
        is_done_invoice: null,
        back_money_way: null,
        strategy_id: null,
        planner_id: null,
        medium_id: null,
        is_quantity: null,
        is_done_stage: '',
        trade: null,
      },
      dialogExecution: false,
      execOrderId: null,
      expandKeys: [],
      openMerge: false
    }
  },
  created() {
    this.getOptions(['pay_methods'])
    this.$nextTick(() => {
      this.getList()
    })
  },
  methods: {
    handleAdd() {
      const {href} = this.$router.resolve({
        name: `createAdOrderWcm`,
        query: { type: "add", isPreExecutor: this.isPreExecutor, cooperation: this.cooperation, pt: this.pt }
      });
      window.open(href, "_blank");
    },
    async handleExport(refName) {
      try {
        const searchCondition = this.$refs.search.handleSearchCondition()
        Object.assign(searchCondition, {orderBy: this.orderBy})
        let name = '营销订单'

        const response = await exportWcm(searchCondition).then(response => {
          return response
        })

        this.$refs[refName].exportSaveXlsx(response, name)

      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
    },
    getOptions(options) {
      getOptionsForSelect(options).then(res => {
        this.pay_methods = res.model.pay_methods || [];
      });
    },
    afterDeal() {
      this.getList()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
      this.pageSelectedList = this.$refs.table.selection
    },
    goDetail(row) {
      //详情页面，修改页面
      this.editPage(row.id)
    },
    editPage(id) {
      const {href} = this.$router.resolve({
        name: 'editAdOrderWcm',
        params: {id: id},
        query: { isPreExecutor: this.isPreExecutor, pt: this.pt },
      });
      window.open(href, "_blank");
    },
    // 操作项
    handleCommand(command, row) {
      switch (command) {
        case 'child': {
          // 添加子订单;
          if (!judgeOrderWholeCase(row)) {
            this.$notify.warning('全案营销订单才能添加子订单');
            return false
          }
          const {href} = this.$router.resolve({
            name: `createAdOrder`,
            query: {type: "child", source_id: row.id, from: 'mark', isPreExecutor: this.isPreExecutor, pt: this.pt}
          });
          window.open(href, "_blank");
          break;
        }
        default: {
          // 默认;
          break;
        }
      }
    },
    showDialogExecution(row) {
      this.dialogExecution = true;
      this.execOrderId = row.id;
    },

    //列表查询
    onSubmit() {
      this.pageData.page = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      if (!this.$refs.search) {
        return;
      }

      const searchCondition = this.$refs.search.handleSearchCondition()

      let reqParams = {...searchCondition, ...this.pageData}
      // 全案营销和年框大全案 的类型区分
      if (this.cooperation) {
        reqParams['form_of_cooperation'] = this.cooperation
      }
      let {data, total, current_page, per_page} = await queryWcmOrdersList(reqParams).then(res => {
        return res.model
      })
      this.key = new Date().getTime();
      this.loading = false
      this.dataList = data
      this.total = total
      this.pageData.page = current_page
      this.pageData.per_page = per_page
      this.offset = (current_page - 1) * per_page;
    }
  }
}
</script>

<style lang="scss">
.wcm-order-container {
  .handle-row {
    .cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .funcbars-button {
    padding: 6px 8px !important;
    color: rgb(254, 45, 84);
    font-size: 12px;
    border: 1px solid rgb(254, 45, 84);
    cursor: pointer;
    flex: 1;
    border-radius: 3px;
  }
}
</style>
